import { generateUtmExt, log } from '../../common/common';
import { grandRoundConstants } from '../constants/grandround.constant';
import { logoutUser } from './login.action';
import axiosInstance from '../helper/axiosInstance';

const getGrSuccess = (payload) => {
  return {
    type: grandRoundConstants.GET_GRANDROUND_LIST_SUCCESS,
    payload
  };
};
const getGrFailure = (payload) => {
  return {
    type: grandRoundConstants.GET_GRANDROUND_LIST_FAILURE,
    payload
  };
};
const getGrDetailsSuccess = (payload) => {
  return {
    type: grandRoundConstants.GET_GRANDROUND_DETAILS_SUCCESS,
    payload
  };
};
const getGrDetailsFailure = (payload) => {
  return {
    type: grandRoundConstants.GET_GRANDROUND_DETAILS_FAILURE,
    payload
  };
};
const getGrSessionSuccess = (payload) => {
  return {
    type: grandRoundConstants.GET_GRANDROUND_SESSION_SUCCESS,
    payload
  };
};
const getGrSessionFailure = (payload) => {
  return {
    type: grandRoundConstants.GET_GRANDROUND_SESSION_FAILURE,
    payload
  };
};
const getGrMedwikiSuccess = (payload) => {
  return {
    type: grandRoundConstants.GET_GRANDROUND_MEDWIKI_SUCCESS,
    payload
  };
};
const getGrMedwikiFailure = (payload) => {
  return {
    type: grandRoundConstants.GET_GRANDROUND_MEDWIKI_FAILURE,
    payload
  };
};
const getGrArchivedSuccess = (payload) => {
  return {
    type: grandRoundConstants.GET_GRANDROUND_ARCHIVE_SUCCESS,
    payload
  };
};
const getGrArchivedFailure = (payload) => {
  return {
    type: grandRoundConstants.GET_GRANDROUND_ARCHIVE_FAILURE,
    payload
  };
};
const getGrSurveySuccess = (payload) => {
  return {
    type: grandRoundConstants.GET_GRANDROUND_SURVEY_SUCCESS,
    payload
  };
};
const getGrSurveyFailure = (payload) => {
  return {
    type: grandRoundConstants.GET_GRANDROUND_SURVEY_FAILURE,
    payload
  };
};
export const getGrList = (pagination, callback) => {
  return async (dispatch) => {
    axiosInstance
      .get(`gr/listing?from=${pagination}&to=10`)
      .then((response) => {
        if (response.data) {
          callback(response.data);
          dispatch(getGrSuccess(response.data));
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        log('error', error);
        callback('error');
        dispatch(getGrFailure(error));
      });
  };
};
export const getGrDetails = (id, callback) => {
  return async (dispatch) => {
    axiosInstance
      .get(`gr/detail?type_id=${id}${generateUtmExt()}`)
      .then((response) => {
        if (response.data) {
          callback(response.data);
          dispatch(getGrDetailsSuccess(response.data));
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        log('error', error);
        callback('error');
        dispatch(getGrDetailsFailure(error));
      });
  };
};

export const getGrSessions = (id, callback) => {
  return async (dispatch) => {
    axiosInstance
      .get(`gr/session?type_id=${id}`)
      .then((response) => {
        if (response.data) {
          callback(response.data);
          dispatch(getGrSessionSuccess(response.data));
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        log('error', error);
        callback('error');
        dispatch(getGrSessionFailure(error));
      });
  };
};
export const getGrMedwiki = (id, callback) => {
  return async (dispatch) => {
    axiosInstance
      .get(`gr/medwiki?type_id=${id}`)
      .then((response) => {
        if (response.data) {
          callback(response.data);
          dispatch(getGrMedwikiSuccess(response.data));
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        log('error', error);
        callback('error');
        dispatch(getGrMedwikiFailure(error));
      });
  };
};
export const getGrArchived = (id, pagination, callback) => {
  return async (dispatch) => {
    axiosInstance
      .get(`gr/archiveVideoList?type_id=${id}&to=5&from=${pagination}`)
      .then((response) => {
        if (response.data) {
          callback(response.data);
          dispatch(getGrArchivedSuccess(response.data));
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        log('error', error);
        callback('error');
        dispatch(getGrArchivedFailure(error));
      });
  };
};
export const getGrSurvey = (id, callback) => {
  return async (dispatch) => {
    axiosInstance
      .get(`gr/survey?type_id=${id}`)
      .then((response) => {
        if (response.data) {
          callback(response.data);
          dispatch(getGrSurveySuccess(response.data));
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        log('error', error);
        callback('error');
        dispatch(getGrSurveyFailure(error));
      });
  };
};
export const likePress = (jsonObj, callback) => {
  return async (dispatch) => {
    axiosInstance
      .post('knwlg/save_like', jsonObj)
      .then((response) => {
        if (response.data) {
          callback(response.data);
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        log('error', error);
        callback('error');
      });
  };
};
export const vaultPress = (jsonObj, callback) => {
  return async (dispatch) => {
    axiosInstance
      .post('knwlg/vault_switching', jsonObj)
      .then((response) => {
        if (response.data) {
          callback(response.data);
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        log('error', error);
        callback('error');
      });
  };
};
